import React from "react";
import Typography from "@material-ui/core/Typography";
import {diferenciasResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import TablaDiferenciasPorUbicacion from "../components/TablaDiferenciasPorUbicacion";

class DiferenciasPorUbicacion extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            datos:[],
            openSnack: false,
            severity: '',
            message: '',
        }
    }

    obtenerDiferencias = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        diferenciasResources.getDiferenciasPorUbicacion().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({datos:result.diferencias})
            }
            else if (result.status_code === 401){
                this.setState({openSnack:true, severity:result.severity, message:result.message})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    UNSAFE_componentWillMount() {
        this.obtenerDiferencias()
    }

    render() {
        return(
            <div>
                <Typography variant="h4" gutterBottom>Diferencias por ubicación</Typography>
                <TablaDiferenciasPorUbicacion datos={this.state.datos}/>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default DiferenciasPorUbicacion;